import { Documento } from './documento';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DocumentoGlobal {

    private TIPO_RG = 1;
    private TIPO_DIPLOMA = 4;
    private TIPO_HISTORICO = 6;

    inscricoes: Array<any> = [];

    private _adicionaDocumentoChanged: BehaviorSubject<Documento> = new BehaviorSubject<Documento>(null);
    private _removeDocumentoChanged: BehaviorSubject<Documento> = new BehaviorSubject<Documento>(null);
    private _imagemDocumentoChanged: BehaviorSubject<Documento> = new BehaviorSubject<Documento>(null);
    private _tipoDocumentoChanged: BehaviorSubject<Documento> = new BehaviorSubject<Documento>(null);

    adicionaDocumentoEmitter: Observable<Documento> = this._adicionaDocumentoChanged.asObservable();
    removeDocumentoEmitter: Observable<Documento> = this._removeDocumentoChanged.asObservable();
    imagemDocumentoEmitter: Observable<Documento> = this._imagemDocumentoChanged.asObservable();
    tipoDocumentoEmitter: Observable<Documento> = this._tipoDocumentoChanged.asObservable();

    constructor() { }

    adicionaDocumento(documento: Documento) {
        this._adicionaDocumentoChanged.next(documento);
    }

    removeDocumento(documento: Documento) {
        this._removeDocumentoChanged.next(documento);
    }

    adicionaImagem(documento: Documento) {
        this._imagemDocumentoChanged.next(documento);
    }

    adicionaTipo(documento: Documento) {
        this._tipoDocumentoChanged.next(documento);
    }


    getTipoDiploma() {
        return this.TIPO_DIPLOMA;
    }


    getTipoHistorico() {
        return this.TIPO_HISTORICO;
    }

    getTipoRg() {
        return this.TIPO_RG;
    }

    setDocumentos(documentos, tipo) {
        if (documentos) {
            documentos.forEach(documento => {
                if (documento.TipDocCod === tipo) {
                    documento.DocCaminho.forEach(caminho => {
                        if (!caminho.VPesDocIdArquivo) {
                            caminho.VPesDocIdArquivo = Math.floor(Math.random() * 5000) + 1;
                        }
                    });
                }
            });
        }

        return documentos;
    }

    adicionaDocumentoGlobal(documentos, adicionaDocumento) {
        if (documentos && adicionaDocumento) {
            documentos.forEach(documento => {
                if (documento.TipDocCod == adicionaDocumento.TipDocCod) {
                    documento.DocCaminho.push({
                        VPesDocIdArquivo: Math.floor(Math.random() * 5000) + 1,
                        caminhoDocItem: ''
                    });
                }
            });
        }

        return documentos;
    }

    removeDocumentoGlobal(documentos, removerDocumento) {

        if (documentos && removerDocumento) {
            documentos.forEach(documento => {
                if (documento.TipDocCod == removerDocumento.TipDocCod) {
                    documento.DocCaminho = [];

                    documento.DocCaminho.push({
                        VPesDocIdArquivo: Math.floor(Math.random() * 5000) + 1,
                        caminhoDocItem: ''
                    });
                }
            });
        }

        return documentos;
    }

    adicionaImagemGlobal(documentos, documentoImagem) {
        if (documentos && documentoImagem) {
            documentos.forEach(documento => {
                if (documento.TipDocCod == documentoImagem.TipDocCod) {
                    documento.DocCaminho.forEach(caminho => {
                        documentoImagem.DocCaminho.forEach(caminhoImagem => {
                            if (caminho.VPesDocIdArquivo == caminhoImagem.VPesDocIdArquivo) {
                                caminho.caminhoDocItem = caminhoImagem.caminhoDocItem;
                                caminho['ExtensaoArq'] = caminhoImagem.ExtensaoArq;
                                documento['classe'] = '';
                            }
                        });
                    });
                }
            });
        }
        return documentos;
    }

    adicionaTipoGlobal(documentos, documentoTipo) {

        if (documentos && documentoTipo) {
            documentos.forEach(documento => {
                if (documento.TipDocCod == documentoTipo.TipDocCod) {
                    documentoTipo.DocCaminho.forEach(caminho => {
                        documento.DocCaminho = [];

                        documento['classe'] = '';
                        documento.DocCaminho.push({
                            VPesDocIdArquivo: Math.floor(Math.random() * 5000) + 1,
                            PrcTipEnt: caminho.PrcTipEnt,
                            caminhoDocItem: '',
                            ExtensaoArq: ''
                        });

                    });
                }
            });
        }

        return documentos;
    }


    validaDocumentosGlobal(documentos, tipo) {
        let documentosValidos = true;

        if (documentos) {
            documentos.forEach(documento => {
                if (documento.TipDocCod === tipo) {
                    documento.DocCaminho.forEach(caminho => {
                        if (
                          caminho.caminhoDocItem === "" &&
                          caminho.PrcTipEnt !== "U" &&
                          caminho.PrcTipEnt !== "C" &&
                          documento.PrcTipDocObr
                        ) {
                          documento["classe"] = "classWarning";

                          if (
                            documento.TipDocDesRed.search(" é obrigatório") ==
                            -1
                          ) {
                            documento.TipDocDesRed =
                              documento.TipDocDesRed + " é obrigatório";
                          }
                          documentosValidos = false;
                        }
                    });
                }
            });
        }

        return [documentos, documentosValidos];
    }

}



// WEBPACK FOOTER //
// ./src/app/_shared/documento/documento-global.ts